import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, Instagram } from 'lucide-react';

/**
 * Global site footer with links to legal + support pages.
 * Rendered inside Layout.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-white/10 bg-black/20" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 py-8 grid md:grid-cols-4 gap-6 text-sm">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-primary/20 flex items-center justify-center">
              <TrendingUp className="w-4 h-4 text-primary" />
            </div>
            <span className="font-bold">TRADEX AI</span>
          </div>
          <p className="text-xs text-muted-foreground leading-relaxed">
            L&apos;IA au service de vos décisions de trading. Analyse, journalisation, Money Management strict.
          </p>
        </div>

        <div>
          <div className="text-xs font-semibold uppercase text-muted-foreground mb-3">Produit</div>
          <ul className="space-y-2">
            <li><Link to="/subscribe" className="hover:text-primary transition-colors">Tarifs</Link></li>
            <li><Link to="/faq" className="hover:text-primary transition-colors" data-testid="footer-faq-link">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-semibold uppercase text-muted-foreground mb-3">Support</div>
          <ul className="space-y-2">
            <li><Link to="/contact" className="hover:text-primary transition-colors" data-testid="footer-contact-link">Nous contacter</Link></li>
            <li>
              <a
                href="https://www.instagram.com/tradexai.fr/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:text-primary transition-colors"
                data-testid="footer-instagram-link"
              >
                <Instagram className="w-4 h-4" />
                <span>Instagram · @tradexai.fr</span>
              </a>
            </li>
            <li><a href="mailto:contact@tradex-ai.fr" className="hover:text-primary transition-colors">contact@tradex-ai.fr</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-semibold uppercase text-muted-foreground mb-3">Légal</div>
          <ul className="space-y-2">
            <li><Link to="/legal/cgu" className="hover:text-primary transition-colors" data-testid="footer-cgu-link">CGU</Link></li>
            <li><Link to="/legal/rgpd" className="hover:text-primary transition-colors" data-testid="footer-rgpd-link">Politique RGPD</Link></li>
            <li><Link to="/legal/cgu#article-1" className="hover:text-primary transition-colors">Mentions légales</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <div>© {year} TRADEX AI — Tous droits réservés</div>
          <div className="flex items-center gap-4">
            <span>🇫🇷 Fait en France</span>
            <span>·</span>
            <span>Analyses IA à titre indicatif — Le trading comporte des risques</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
